<template>
    <div class="advisor-container">
        <img class="lock" :src="Lock" alt="Lock">
        <img class="advisor" :src="Advisor" alt="Advisor">

        <router-link tag="img" :to="{ name: 'MyAdvices' }" class="btn-ontop" :src="MSG" alt="MSG"></router-link>
        <router-link tag="img" :to="{ name: 'MyAdvisor' }" class="btn-ontop" :src="Timer" alt="Timer"></router-link>

        <div class="text-container">
            <img class="moshavereh" :src="Moshavereh" alt="Moshavereh">
            <span>{{ advisorText }}</span>
        </div>

        <div class="btn-container">
            <button 
                style="width: calc(100% - 15px);"
                class="btn btn-primary advice-btn"
                @click="AdviceRequest('Attendance')"
            >
                <img :src="Attendance" alt="Attendance">
                <span>مشاوره حضوری</span>
            </button>

            <button 
                style="margin-right: 7.5px;"
                class="btn btn-primary advice-btn"
                @click="AdviceRequest('VideoOnline')"
            >
                <img :src="VideoOnline" alt="Attendance">
                <span>ویدیوئی (آنلاین)</span>
            </button>

            <!-- 
            <button 
                class="btn btn-primary advice-btn"
                @click="AdviceRequest('WritingOnline')"
            >
                <img :src="WritingOnline" alt="Attendance">
                <span>کتبی (آنلاین)</span>
            </button> 
            -->
            
            <button 
                style="margin-left: 7.5px;"
                class="btn btn-primary advice-btn"
                @click="AdviceRequest('Telephonic')"
            >
                <img :src="Telephonic" alt="Attendance">
                <span>مشاوره تلفنی</span>
            </button>
        </div>

        <!-- Modals -->
        <request-modal :submitRequest="Submit" :type="requestType"/>
    </div>
</template>

<script>
import Lock from '@/assets/images/advisor/lock.png';
import Advisor from '@/assets/images/teacher_test.png';


import Attendance from '@/assets/images/advisor/attendance.png';
import Telephonic from '@/assets/images/advisor/telephonic.png';
import VideoOnline from '@/assets/images/advisor/video-online.png';
import WritingOnline from '@/assets/images/advisor/writing-online.png';

import MSG from '@/assets/images/advisor/msg.png';
import Timer from '@/assets/images/advisor/timer.png';
import Moshavereh from '@/assets/images/advisor/moshavereh.png';

import RequestModal from '@/components/modals/request_modal';

import { postRequest, getRequest } from '@/utils/libs/api-request';
const uniqid = require('uniqid');
import Cookies from 'js-cookie';

export default {
    name: 'Advisor',
    data() {
        return {
            Lock: Lock,
            Advisor: Advisor,
            advisorText: 'انجام مشاوره های تخصصی آنلاین در حوزه های مختلف به صورت ویدیویی و کتبی، و امکان ثبت درخواست برای مشاوره های حضوری و تلفنی',

            MSG: MSG,
            Timer: Timer,

            Moshavereh: Moshavereh,

            Attendance: Attendance,
            Telephonic: Telephonic,
            VideoOnline: VideoOnline,
            WritingOnline: WritingOnline,

            requestType: undefined
        }
    },
    components: {
        RequestModal
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            getRequest('/cms/find-top')
                .then((rsp) => {
                    let data = rsp['data'][0]

                    if(data) {
                        this.advisorText = data.AdvisorText;
                    }
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        AdviceRequest(type) {
            this.requestType = type;
            this.$modal.show('request-modal');
        },
        Submit(type, subject) {
            postRequest('/advice-requests/create', {
                subject: subject,
                type: type
            })
                .then(() => {
                    // response
                    this.$emit('alertMsg', 
                        { message: 'درخواست ثبت گردید', key: uniqid(), type: 'success' }
                    )
                })
                .catch((err) => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                        else {
                            this.$emit('alertMsg', 
                                { message: err.response.data.message, key: uniqid(), type: 'error' }
                            )
                        }
                    }
                });
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.advisor-container {
    width: 100%;

    position: relative;
    background-color: #2ad85f;
}
.advisor-container .btn-ontop {
    width: 30pt;
    height: 30pt;
    margin: 10pt 10pt 0 3pt;

    cursor: pointer;
    opacity: .7;
    
    position: relative;
    z-index: 1;
}
.advisor-container .btn-ontop:hover {
    opacity: 1;
}
.advisor-container .lock {
    width: 50%;
    max-width: 250pt;

    position: absolute;
    top: 0;
    left: 0;
}
.advisor-container .advisor {
    width: 80vw;
    max-width: 250pt;

    position: absolute;
    top: 12.5vh;
    left: -10vh;
}

/* ---------------------------------------- */
/* ------------ TEXT CONTAINER ------------ */
/* ---------------------------------------- */
.advisor-container .text-container {
    max-width: 150pt;
    text-align: center;

    position: absolute;
    top: 10vh;
    right: 2.5vw;
    z-index: 10;

    color: #fff;
}
.advisor-container .text-container .moshavereh {
    max-width: 150pt;
}
.advisor-container .text-container span {
    display: inline-block;

    font-size: .9rem;
    font-weight: bold;
    margin-top: 15px;
}

/* ---------------------------------------- */
/* ------------- BTN CONTAINER ------------ */
/* ---------------------------------------- */
.advisor-container .btn-container {
    min-height: 35vh;
    width: 100%;
    
    position: absolute;
    top: calc(65vh - 50pt);
    left: 0;

    display: flex;
    flex-wrap: wrap;
}
.advisor-container .btn-container .advice-btn {
    width: calc(50% - 10px);
    height: calc(17.5vh - 5px);
    margin: 0 auto auto auto;

    border-radius: 15pt;
    background-color: #24327c;
    border-color: #24327c;
}
.advisor-container .btn-container .advice-btn img {
    width: 30pt;
    margin: auto;
    display: block;
}
.advisor-container .btn-container .advice-btn span {
    font-size: 12px;
    font-weight: bold;
}
</style>
